import styled, { css, keyframes } from 'styled-components';
import { Palette } from 'config';
import { Link } from 'react-router-dom';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Slice = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 800000;
`;

export const DotsContainer = styled.div`
  position: relative;
`;

export const ParentContainer = styled.div`
  position: relative;
`;

export const DotsHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 32px;
  height: 32px;
  svg {
    fill: ${Palette.PrimaryGray._900};
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
      border-radius: 4px;
      svg {
        fill: ${Palette.Primary._500};
      }
    `};
`;

export const DropDownList = styled('ul')`
  z-index: 100;
  width: 182px;
  height: auto;
  background-color: white;
  border: 1px solid #e2e8f0;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  border-radius: 4px;
  padding: 8px;
  margin: 0;
  animation: ${fadeIn} 0.2s ease-out forwards;
`;

export const ListItem = styled('li')`
  list-style: none;
  background: #ffffff;
  color: ${Palette.PrimaryGray._700};
  cursor: pointer;
  height: 40px;
  display: flex;
  padding: 0 16px 0 8px;
  align-items: center;
  border: 1px solid #ffffff;
  span {
    margin-right: 13px;
    display: flex;
  }

  svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    fill: ${Palette.PrimaryGray._400};
  }

  :active {
    border: 1px solid ${() => Palette.Primary._300};
    color: ${() => Palette.Primary._500};
  }

  :hover {
    border-radius: 4px;
    background: ${() => Palette.PrimaryGray._100};
    svg {
      fill: ${Palette.Primary._500};
    }
  }
  transition: all 0.2s linear;
`;

export const MyLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;

  :active {
    color: ${() => Palette.Primary._500};
  }
`;
